import {createRequest} from './createRequest';
import {antiCheatBeforeRequest} from '@/services/antiCheat';

export {RequestError} from './errors';
export type {RequestInstance, RequestOptions} from './types';

const request = createRequest();
request.useBeforeRequest(antiCheatBeforeRequest);

export default request;
